<template>
  <div
    class="audio-container"
    :id="content.key"
  >
    <el-image
      class="image"
      :id="`${content.key}-1`"
      :src="content.collectionCover.img"
      :style="{
        width: canSetWidth ? content.collectionCover.width : ''
      }"
      @click="audioPlayerShow"
    ></el-image>
    <p
      class="audio-title"
      :id="`${content.key}-2`"
      :style="{
        fontFamily: content.collectionCover.titleStyle.fontFamily || '',
        fontSize: (content.collectionCover.titleStyle.fontSize + 'px') || '',
        lineHeight: (content.collectionCover.titleStyle.lineHeight + 'px') || '',
        textIndent: (typeof content.titleStyle.textIndent === 'string') ? content.titleStyle.textIndent :
          (typeof content.titleStyle.textIndent === 'number') ? (content.titleStyle.textIndent + 'rem') : '',
        fontWeight: content.collectionCover.titleStyle.fontWeight || '',
        textDecoration: content.collectionCover.titleStyle.underline === 1 ? 'underline' : '',
        fontStyle: content.collectionCover.titleStyle.fontItalic === 1 ? 'italic' : '',
        textAlign: content.collectionCover.titleStyle.textAlign || '',
        color: content.collectionCover.titleStyle.color || '',
        backgroundColor: content.collectionCover.titleStyle.backgroundColor || '',
      }"
    >{{ content.collectionCover.title }}</p>
    <audioPlayer :dialogTitle="dialogTitle" :visible="dialogVisible" :audioList="content.content" @dialogClose="audioPlayerHide"></audioPlayer>
  </div>
</template>

<script>
/*
音频集合的封面样式
*/
import audioPlayer from "../../popup/audioListPlayer.vue";
export default {
  name: "audioUnitCollection",
  components: {
    audioPlayer
  },
  props: {
    content: {
      type: Object,
      default: () => {
        return {};
      }
    },
    canSetWidth: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dialogTitle: '播放音频',
      dialogVisible: false
    }
  },
  methods: {
    audioPlayerShow() {
      this.dialogVisible = true
    },
    audioPlayerHide() {
      this.dialogVisible = false
    },
  }
}
</script>

<style lang="scss" scoped>
.audio-container {
  width: 100%;

  .image{
    width: 100%;
    height: auto;
    display: block;
    margin: 0 auto 10px;
    cursor: pointer;
  }

  .audio-title{
    display: block;
    margin-bottom: 10px;
    width: 100%;
    text-align: center;
    font-size: 16px;
    color: #00a8ac;
  }
}
</style>